import ArticleLink from '@/components/feature/ArticleLink';
import { platformGuides } from '@/mocks/home';
import CandleChart from '@/components/charts/CandleChart';
import ScrollReveal from '@/components/base/ScrollReveal';
import SectionHeading from '@/components/base/SectionHeading';

export default function PlatformSection() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20 lg:px-10">
        <SectionHeading
          eyebrow="แพลตฟอร์มเทรด"
          title="เรียนรู้ MT4 และ MT5"
          subtitle="คู่มือการใช้งานแพลตฟอร์ม Forex สำหรับผู้เริ่มต้น เข้าใจทุกปุ่มก่อนเทรดจริง"
        />

        <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-2">
          {platformGuides.map((platform, index) => (
            <ScrollReveal key={platform.name} delay={index * 100}>
              <div className="flex h-full flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50">
                <div className="flex items-center justify-between border-b border-background-200 px-6 py-5">
                  <div>
                    <h3 className="font-heading text-xl font-semibold text-foreground-950">{platform.name}</h3>
                    <p className="text-xs text-foreground-500">{platform.full}</p>
                  </div>
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-50 text-primary-700">
                    <i className="ri-computer-line text-xl" />
                  </span>
                </div>

                <div className="border-b border-background-200 bg-background-100/70 px-6 py-5">
                  <div className="rounded-lg border border-background-200 bg-background-50 p-3">
                    <div className="flex items-center justify-between">
                      <span className="flex items-center gap-2 font-num text-xs text-foreground-600">
                        <span
                          className={`h-1.5 w-1.5 rounded-full ${platform.accent ? 'bg-accent-500' : 'bg-primary-500'}`}
                        />
                        {platform.name} · {platform.symbol} · {platform.timeframe}
                      </span>
                      <span className="flex gap-1">
                        <span className="h-2 w-2 rounded-sm bg-background-300" />
                        <span className="h-2 w-2 rounded-sm bg-background-300" />
                        <span className="h-2 w-2 rounded-sm bg-background-300" />
                      </span>
                    </div>
                    <div className="mt-3">
                      <CandleChart compact variant={platform.chart === 'mt5' ? 'mt5' : 'mt4'} />
                    </div>
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-6">
                  <p className="text-sm leading-relaxed text-foreground-600">{platform.desc}</p>
                  <ul className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2">
                    {platform.items.map((item) => (
                      <li key={item} className="flex items-center gap-2.5 text-sm text-foreground-800">
                        <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
                          <i className="ri-check-line text-sm" />
                        </span>
                        {item}
                      </li>
                    ))}
                  </ul>
                  <ArticleLink
                    to={platform.path}
                    className="mt-6 inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                  >
                    ดูคู่มือ {platform.name}
                    <i className="ri-arrow-right-line text-base" />
                  </ArticleLink>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}